// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"19":"b55d3d12","478":"682f2a6e","924":"8faf3c2c"}[chunkId] + ".js";
};